import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// 防止路由重复加载报错
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
};
const router = new Router({
    routes: [
        {
            path: '',
            redirect: 'index'
        },
        {
            path: '/404',
            name: 'page404',
            component: () => import('@/views/errorPage/404.vue'),
            meta: {
                title: '404',
                parentTitle: ''
            }
        },
        {
            path: '*', // 页面不存在的情况下会跳到404页面
            redirect: '/404',
            name: 'notFound',
            hidden: true
        },
        {
            path: '/',
            component: () => import('@/layout/mainLayout.vue'),
            children: [
                {
                    path: "/index",
                    name: 'index',
                    component: () => import('@/views/homePage/index.vue')
                },
                {
                    path: "/productCenter/dataPlatform",
                    name: 'dataPlatform',
                    component: () => import('@/views/productCenter/dataPlatform/index.vue')
                },
                {
                    path: "/productCenter/investBuild",
                    name: 'investBuild',
                    component: () => import('@/views/productCenter/investBuild/index.vue')
                },
                {
                    path: "/productCenter/largeModel",
                    name: 'largeModel',
                    component: () => import('@/views/productCenter/largeModel/index.vue')
                },

                {
                    path: "/productCenter/eCommercePlatform",
                    name: 'eCommercePlatform',
                    component: () => import('@/views/productCenter/eCommercePlatform/index.vue')
                },
                {
                    path: "/productCenter/digitalSolutions",
                    name: 'digitalSolutions',
                    component: () => import('@/views/productCenter/digitalSolutions/index.vue')
                },
                {
                    path: "/productCenter/inteIndustryEdu",
                    name: 'inteIndustryEdu',
                    component: () => import('@/views/productCenter/inteIndustryEdu/index.vue')
                },
                {
                    path: "/productCenter/digitalCompService",
                    name: 'digitalCompService',
                    component: () => import('@/views/productCenter/digitalCompService/index.vue')
                },
                {
                    path: "/productCenter/humanResourceService",
                    name: 'humanResourceService',
                    component: () => import('@/views/productCenter/humanResourceService/index.vue')
                },
                {
                    path: "/businessCenter",
                    name: 'businessCenter',
                    component: () => import('@/views/businessCenter/index.vue')
                },
                {
                    path: "/scineResult",
                    name: 'scineResult',
                    component: () => import('@/views/scineResult/index.vue')
                },
                {
                    path: "/newsCenter",
                    name: 'newsCenter',
                    component: () => import('@/views/newsCenter/index.vue')
                },
                {
                    path: "/newsDetail",
                    name: 'newsDetail',
                    component: () => import('@/views/newsCenter/newsDetail.vue')
                },
                {
                    path: "/aboutAs",
                    name: 'aboutAs',
                    component: () => import('@/views/aboutAs/index.vue')
                }
            ]
        },

    ]
});
export default router;
